module.exports = __webpack_public_path__ + "static/media/a6.58d1c1cf.png";